import { stringifyUrl } from "query-string"
import { idToStrongId } from "@oysterhr/common"
import { ChargeState, InvoiceBusinessState } from "@oysterhr/schema"
import { companyInvoicesPath } from "@oysterhr/router"
import { staffInvoicesPath } from "./staff"

export const companyUnpaidInvoicesPath = ({
  isStaff,
  companyId,
}: {
  companyId: string
  isStaff: boolean
}) => {
  const chargeStates = [
    ChargeState.Pending,
    ChargeState.ManualProcessNotPaid,
    ChargeState.ChargedBack,
    ChargeState.AutomatedProcessInProgress,
    ChargeState.AutomatedProcessFailed,
    ChargeState.AutomatedProcessConfirmed,
    ChargeState.Overdue,
    ChargeState.PartiallyPaid,
  ]
  const invoiceBusinessStates = [
    InvoiceBusinessState.WaitingApproval,
    InvoiceBusinessState.ReadyForReview,
    InvoiceBusinessState.Approved,
    InvoiceBusinessState.AutoApproved,
    InvoiceBusinessState.Disputed,
  ]

  if (isStaff) {
    return stringifyUrl({
      url: staffInvoicesPath(),
      query: {
        chargeStates,
        invoiceBusinessStates,
        companyId: idToStrongId(companyId),
      },
    })
  }

  return stringifyUrl({
    url: companyInvoicesPath(companyId),
    query: {
      chargeStates: chargeStates.join(","),
      invoiceBusinessStates: invoiceBusinessStates.join(","),
    },
  })
}
